var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { createStore, Provider } from 'jotai';
import { Provider as ReduxProvider } from 'react-redux';
import { getRoutes } from "./Routes";
import CustomProvider from "./App/Provider";
import { settingsAtom, templatesAtom, translationsAtom } from "./V2/atoms";
import { relationshipTypesAtom } from "./V2/atoms/relationshipTypes";
import { store } from "./store";

const reduxState = store === null || store === void 0 ? void 0 : store.getState();

const settings = (reduxState === null || reduxState === void 0 ? void 0 : reduxState.settings.collection.toJS()) || {};
const templates = (reduxState === null || reduxState === void 0 ? void 0 : reduxState.templates.toJS()) || [];

const router = createBrowserRouter(getRoutes(settings, reduxState === null || reduxState === void 0 ? void 0 : reduxState.user.get('_id')));

const atomStore = createStore();
atomStore.set(settingsAtom, settings);
atomStore.set(templatesAtom, templates);
atomStore.set(translationsAtom, { locale: (reduxState === null || reduxState === void 0 ? void 0 : reduxState.locale) || 'en' });

//sync deprecated redux store
atomStore.sub(settingsAtom, () => {
  const value = atomStore.get(settingsAtom);
  store === null || store === void 0 ? void 0 : store.dispatch({ type: 'settings/collection/SET', value });
});
atomStore.sub(templatesAtom, () => {
  const value = atomStore.get(templatesAtom);
  store === null || store === void 0 ? void 0 : store.dispatch({ type: 'templates/SET', value });
});
atomStore.sub(relationshipTypesAtom, () => {
  const value = atomStore.get(relationshipTypesAtom);
  store === null || store === void 0 ? void 0 : store.dispatch({ type: 'relationTypes/SET', value });
});

const App = () => /*#__PURE__*/
_jsx(ReduxProvider, { store: store }, void 0, /*#__PURE__*/
_jsx(CustomProvider, {}, void 0, /*#__PURE__*/
_jsx(Provider, { store: atomStore }, void 0, /*#__PURE__*/
_jsx(RouterProvider, { router: router, fallbackElement: null })
)
)
);


export { App };